<template>
  <div class="app-main-layout">
    <NavigationBar @menulogoclick="isOpen = !isOpen" />
    <SideBar v-model="isOpen" @menubackclick="isOpen = !isOpen" />
    <main class="app-content full">
      <div class="app-page">
        <router-view />
      </div>
    </main>
  </div>
</template>

<script>
import NavigationBar from "@/components/NavigationBar";
import SideBar from "@/components/SideBar";

export default {
  name: "main-layout",
  data: () => ({
    isOpen: false,
  }),
  components: {
    NavigationBar,
    SideBar,
  },
  mounted() {
    const user = JSON.parse(localStorage.getItem("User"));
    if (!user) {
      this.$router.push("/login?message=logout");
    }
    if (this.$router.currentRoute.name != "FirstLogin") {
      const User = JSON.parse(localStorage.getItem("User"));
      if (User.passwordMustChanged) {
        this.$router.push("/firstlogin");
      }
    }
  },
};
</script>
